import React, {useState, useEffect} from 'react'
import { compose } from 'recompose';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import axios from "axios";
import StyledIcon from '../../../../../../../styledComponents/styles/Icon.styled';
import style from "../modals/ImageUploadModal/style.scss";
import UnsplashBlankIcon from '../../../../../../travelerProfile/components/icons/UnsplashBlankIcon';
import CircleTickIcon from '../../../../../../travelerProfile/components/icons/CircleTickIcon';

export const enhance = compose(withStyles(style));
const UNSPLASH_ACCESS_KEY = "i-_A5s97mXENnUfcWu6Pmr6bVDq0Q7MIK-523D4UE1c"; 

const keywords = [
  "Italy", 
  "Spain", 
  "United Kingdom", 
  "France", 
  "Germany", 
  "Iconic Landmarks", 
  "Cultural Activities",
  "Academic Settings",
  "Student Life",
  "Scenic Landscapes"
]

const UnsplashImageForm = ({handleUnsplashFileUpload}) => {
  const [query, setQuery] = useState("");
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState([])

  const searchImages = async (searchKey=null) => {
    //const keyWord =  query;
    const response = await axios.get("https://api.unsplash.com/search/photos", {
      params: { query },
      headers: { Authorization: `Client-ID ${UNSPLASH_ACCESS_KEY}` },
    });
    setImages(response.data.results);
  };

  // const convertToBase64 = async (url) => {
  //   try {
  //     const response = await fetch(url);
  //     const blob = await response.blob();
  
  //     return new Promise((resolve) => {
  //       const reader = new FileReader();
  //       reader.onloadend = () => resolve(reader.result);
  //       reader.readAsDataURL(blob);
  //     });
  //   } catch (error) {
  //     console.error("Error converting image to base64:", error);
  //     return null;
  //   }
  // };

  const handleSelectedImage = async  (image) => {
    const responseData =  {
        "url" : image.urls.full,
        "name" : image.alt_description,
        "id" : image.id
      }
      setSelectedImage(prevIds => 
        prevIds.includes(image.id) 
          ? prevIds.filter(id => id !== image.id) 
          : [...prevIds, image.id]
    );
    handleUnsplashFileUpload(responseData);
  }

  return (
    <div  className={style.contentWrapper}>
      <div className={style.modalTitle}>Unsplash</div>
      <div className={style.modalSubTitle}>Browse and select images from Unsplash to add to your program brochure carousel.</div>

      <div className={style.inputWrapper}>
        <label for="unsplash-search">Search Unsplash</label>
        <div className="input-group mb-3">
          <input
            type="text"
            placeholder="Search..."
            value={query}
            id={"unsplash-search"}
            className="form-control"
            onChange={(e) => {
                if(e.target.value==='') {
                  setImages([])
                }
                setQuery(e.target.value)
              }
            }
          />
          <div className="input-group-append">
            <button className={`${style.searchButton} input-group-text`} onClick={searchImages}>
              <StyledIcon type='Search' size='20px' /> 
              <span>Search</span>
            </button>
          </div>
        </div>
      </div>
      <div className={`${style.searchKeyword}`}>
        {query=='' && keywords.map((keyword)=>(
            <button 
              type="button" 
              onClick={()=>{
                  setQuery(keyword);
                  //searchImages(keyword);
                }
              } 
            className={`${style.keywords}`}>{keyword}</button>
          )
        )}
      </div>
      {images.length===0 &&
      <div className={`${style.noImageContainer}`}>
        <div><UnsplashBlankIcon /></div>
        <div className={`${style.noImageDesc}`}>Start exploring images by typing a keyword into the search field or selecting a quick search button.</div>
      </div>
      }
      {images.length>0 &&
        <div className={`${style.imageContainer}`}>
          {images.map((img, index) => (
            <div onClick={()=>handleSelectedImage(img)} className={`${style.imageWrapper} ${selectedImage.find(item=>item===img?.id) ? style.imageWrapperSelected : ""} `} key={index}>
              {selectedImage.find(item=>item===img?.id) && 
                <div className={`${style.unsplashImageHeader}`}>
                  <div>
                    <CircleTickIcon />
                  </div>
                </div>
              }
              <img
                src={img.urls.small}
                alt={img.alt_description}
                className={style.image}
              />
            </div>
          ))}
        </div>
      }
    </div>
  )
}

export default enhance(UnsplashImageForm)
